import Model from '@/models/Model'

export default class QuickSearch extends Model {
    resource() {
        return 'quicksearch'
    }
}
